import { gql } from '@apollo/client';

export const LIST_INVENTORY = gql`
  query list_inventory($data: ListInventoryInputType) {
    list_inventory(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_PRODUCT = gql`
  query get_product($data: GetProductInputType) {
    get_product(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const ADD_PRODUCT = gql`
  mutation add_product($data: AddProductInputType!) {
    add_product(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation delete_product($data: DeleteProductInputType!) {
    delete_product(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const SEARCH_PRODUCTS = gql`
  query search_products($data: SearchProductsInputType!) {
    search_products(data: $data) {
      hasError
      message
      data {
        searchTerm
        products {
          _id
          agent_id
          title
          description
          totalInventory
          priceRangeV2 {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          mainImageURL
          variants {
            id
            title
            price
            compareAtPrice
            inventoryQuantity
            sku
          }
          media {
            id
            originalSrc
            altText
          }
          isActive
          onlineStorePreviewUrl
          score
        }
        totalFound
      }
    }
  }
`;

export interface SearchProductsInput {
  agent_id: string;
  searchTerm: string;
  limit?: number;
  filters?: Record<string, any>;
}


export const GET_INTEGRATIONS_BY_TYPE = gql`
  query get_integrations_by_type($data: GetIntegrationsByTypeInputType!) {
    get_integrations_by_type(data: $data) {
      hasError
      message
      data
    }
  }
`;


